export const REDCRSS_EVENTS = {
  ONBOARDING: 'Onboarding',
  ONBOARDING_COMPLETED: 'Onboarding Completed',
  VIEWED_B2B_PAGE: 'B2B',
  CTA_CLICK: 'CTA Clicked',
  USER_ACTIVATED: 'New User Activated',
  POPUP_SHOWN: 'Pop-up Shown',
  MOBILE_LINK_REQUESTED: 'Installation Link Mobile Requested',
  SEND_TO_DEVELOPER: 'Send to developer',
  SEND_EMAIL: 'Send email',
  PASSWORD_CHANGED: 'Password changed',
  ACTIVATION_STEP: 'Activation Step',
  PRODUCT: 'Reviews',
  BUTTON_CLICK: 'Button Clicked',
  COLLECT_REVIEWS: 'Collect Reviews',
  CUSTOMIZE_WIDGET: 'Customize Widget',
  INTEGRATE: 'Integrate',
  STARTED: 'Started',
  COMPLETED: 'COMPLETED',
  REVIEWS_ACTIVATION: 'Reviews Activation',
  EMAIL_INSTRUCTIONS: 'Email Instructions',
  SEND_INSTRUCTIONS: 'Send Instructions',
  BACK: 'Back',
  INSTALL_LATER: 'I\'ll Install later',
  MANUAL_INSTALLATION: 'Manual Installation',
  AUTO_INSTALLATION: 'Automatic Installation',
  SKIP: 'Skip Installation'
};

export const REDCRSS_EVENT_TYPES = {
  INTERNAL_CHECK: 'Internal Check'
};

export const REDCRSS_EVENT_PROPERTIES = {
  PRODUCT: 'Reviews'
};
